import { useRef, useMemo } from "react";
import { hlYAML } from "../highlights/hlYAML";
import { XIcon } from "../ui/Icons";

const FALLBACK_SLUG = "proc_creation_win_ps_download_cradle";

interface Props {
  value: string;
  onChange: (v: string) => void;
  onClear?: () => void;
  yamlSlug?: string;
}

export function CodeEditor({ value, onChange, onClear, yamlSlug }: Props) {
  const lnRef = useRef<HTMLDivElement>(null);
  const hlRef = useRef<HTMLDivElement>(null);

  const lineNums = useMemo(
    () => value.split("\n").map((_, i) => i + 1).join("\n"),
    [value]
  );
  const yamlHtml = useMemo(() => hlYAML(value), [value]);
  const filename = `${yamlSlug || FALLBACK_SLUG}.yml`;

  const onScroll = (e: React.UIEvent<HTMLTextAreaElement>) => {
    const t = e.currentTarget;
    if (lnRef.current) lnRef.current.scrollTop = t.scrollTop;
    if (hlRef.current) { hlRef.current.scrollTop = t.scrollTop; hlRef.current.scrollLeft = t.scrollLeft; }
  };

  return (
    <>
      <div className="panel-hdr">
        <span className="lang-badge lb-yaml">YAML · Sigma</span>
        <span className="panel-fname">{filename}</span>
        <div className="panel-btns">
          {onClear && <button className="phbtn" onClick={onClear}><XIcon size={11} /> Clear</button>}
        </div>
      </div>
      <div className="editor-wrap">
        <div className="line-nums" ref={lnRef}>{lineNums}</div>
        <div className="editor-core">
          <div
            className="hl-layer"
            ref={hlRef}
            dangerouslySetInnerHTML={{ __html: yamlHtml }}
          />
          <textarea
            className="code-ta"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onScroll={onScroll}
            spellCheck={false}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
          />
        </div>
      </div>
    </>
  );
}
